/* eslint-disable prettier/prettier */
import React from "react";

const Estimate = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2774 4.54063C11.0342 4.34867 10.6758 4.39983 10.4838 4.64304C10.2919 4.88626 10.343 5.24464 10.5862 5.43662C11.623 6.24304 12.2119 7.44627 12.2119 8.75182C12.2118 11.0686 10.3174 12.9502 8.00067 12.9502C5.68394 12.9502 3.78947 11.0686 3.78947 8.75182C3.78947 6.55022 5.50465 4.73262 7.66787 4.56622L7.14305 5.09104C6.92546 5.30863 6.92546 5.66702 7.14305 5.88462C7.25823 5.9998 7.39903 6.05105 7.53983 6.05105C7.68063 6.05105 7.82143 5.99989 7.9366 5.88462L9.4342 4.38702C9.53662 4.28461 9.60063 4.1438 9.60063 3.99024C9.60063 3.83669 9.53661 3.69587 9.4342 3.59347L7.9366 2.08311C7.71902 1.86552 7.36063 1.86552 7.14303 2.08311C6.92543 2.3007 6.92544 2.65909 7.14303 2.87669L7.69338 3.42704C4.90298 3.59347 2.67578 5.91024 2.67578 8.75184C2.67578 11.6958 5.06938 14.0766 8.00058 14.0766C10.9318 14.0766 13.3254 11.683 13.3254 8.75184C13.3254 7.08782 12.583 5.56464 11.2773 4.54064L11.2774 4.54063Z"
      fill="#06AE00"
    />
    <path
      d="M7.41226 9.1869L6.52903 8.30368C6.31145 8.08609 5.95306 8.08609 5.73546 8.30368C5.51787 8.52127 5.51787 8.87966 5.73546 9.09726L7.01546 10.3773C7.11787 10.4797 7.25868 10.5437 7.41223 10.5437C7.56579 10.5437 7.70661 10.4797 7.80901 10.3773L10.2666 7.91966C10.4842 7.70207 10.4842 7.34368 10.2666 7.12608C10.049 6.90849 9.69063 6.90849 9.47303 7.12608L7.41226 9.1869Z"
      fill="#06AE00"
    />
  </svg>
);

export default Estimate;
